export default __webpack_public_path__ + "fe81fc881b44f7878ad59b2b4412bcee.svg";